import { DemoQuestion } from '../../types/questions';

// 데모 문제 - 처음 2개 챕터의 흥미로운 12개 문제
// 전체 코스의 품질과 매력을 보여주기 위해 설계되었습니다!
// 각 옵션별 개별 설명이 포함된 업데이트된 구조 (expA, expB, expC, expD)
export const demoQuestions: DemoQuestion[] = [
  {
    id: 1,
    text: "당신의 스마트폰이 얼굴 인식으로 잠금을 해제합니다. 이것은 어떤 유형의 AI인가요?",
    options: [
      "약인공지능 - 하나의 특정 작업을 위해 설계됨",
      "범용인공지능 - 인간이 할 수 있는 모든 것을 할 수 있음",
      "초인공지능 - 모든 면에서 인간보다 똑똑함",
      "인공일반지능 - 인간처럼 사고함"
    ],
    correct: 0,
    expA: "정확해요! 얼굴 인식은 하나의 특정 작업을 위해 만들어진 약인공지능이에요. 시를 쓰거나 자동차를 운전하거나 피자를 주문할 수는 없거든요 (그럴 수 있다면 정말 멋지겠지만요!) - 얼굴 인식만 정말 잘해요! 그래서 약인공지능 테스팅은 기존 소프트웨어 테스팅과 다른 거예요. 📱✨",
    expB: "틀렸어요 - 범용인공지능은 아직 존재하지 않아요! 우리가 아직 연구하고 있는 단계죠. 당신의 폰은 똑똑하지만, 교향곡을 작곡하거나 세계 평화를 이루지는 못해요 - 당신의 아름다운 얼굴을 보고 잠금만 해제할 뿐이에요! 😊",
    expC: "너무 미래적이에요! 초인공지능은 이론적 개념으로, 모든 면에서 인간보다 똑똑할 거예요. 당신 폰의 얼굴 인식은 인상적이지만, 세계 정복을 계획하지는 않아요 - 그냥 인스타그램에 더 빨리 들어가게 도와줄 뿐이죠! 🤖",
    expD: "아니에요, 그건 범용인공지능과 같은 거예요! AGI는 AI 연구의 성배지만, 아직 거기까지 가지 못했어요. 당신의 폰은 그냥 얼굴을 인식할 뿐, 인간처럼 생각하지는 않아요 - 물론 가끔 제 아침 헤어스타일을 판단하는 것 같긴 하지만요! 😅",
    points: 1,
    chapter: "AI 개론",
    difficulty: "K1"
  },
  {
    id: 2,
    text: "유명한 'AI 효과'가 실제로 작동하는 시나리오는 무엇인가요?",
    options: [
      "AI가 모든 곳에서 인간의 일자리를 빼앗는 것 (고마워, 로봇들아! 🤖)",
      "체스 컴퓨터는 한때 'AI'로 여겨졌지만 지금은 '그냥 알고리즘'이라고 부름",
      "AI가 SF 영화처럼 자각을 갖게 되는 것",
      "AI 시스템이 똑똑해질수록 더 비싸지는 것"
    ],
    correct: 1,
    expA: "부정확해요 - 일자리 대체는 AI 효과가 아니에요! 그건 다른 (그리고 매우 현실적인) 문제죠. AI 효과는 인식에 관한 것이지, 고용에 관한 게 아니에요. 하지만 그렇게 생각하신 이유는 이해해요 - 그것도 AI의 효과 중 하나니까요! 💼",
    expB: "바로 그거예요! AI 효과는 어제의 '놀라운 AI'가 오늘의 '평범한 알고리즘'이 되는 현상이에요. 체스 컴퓨터는 혁명적인 AI였는데, 지금은 그냥... 체스 프로그램이죠! 스마트폰이 '마법'에서 '어, 충전기 어디 있지?'로 바뀐 것처럼요! 🏆➡️💻",
    expC: "너무 할리우드적이에요! 자각하는 AI는 AI 효과가 아니라 'AI 아포칼립스'에 가까워요! AI 효과는 훨씬 미묘해요 - 우리가 지능을 어떻게 인식하는지에 관한 것이지, 로봇 반란에 관한 게 아니에요. 🎬",
    expD: "정확하지 않아요 - 가격은 AI 효과가 아니에요! 실제로 AI는 시간이 지나면서 더 저렴해지는 경우가 많아요 (당신의 폰을 보세요!). AI 효과는 우리가 '진짜' AI라고 여기는 기준이 계속 높아지는 현상이에요. 💰",
    points: 1,
    chapter: "AI 개론",
    difficulty: "K1"
  },
  {
    id: 3,
    text: "의료 조언을 제공하는 챗봇을 테스트하고 있습니다. 가장 큰 우려사항은 무엇인가요?",
    options: [
      "질문에 얼마나 빨리 답하는지 (속도가 생명!)",
      "사용자 친화적인 인터페이스를 가지고 있는지",
      "사람들에게 해를 끼치지 않는 정확하고 편견 없는 조언을 제공하는지",
      "대화 중 서버 메모리를 얼마나 사용하는지"
    ],
    correct: 2,
    expA: "속도는 중요하지만 가장 중요한 건 아니에요! 건강에 대한 빠른 틀린 답변은 위험할 수 있어요. 즉각적인 잘못된 정보를 받는 것보다는 정확한 조언을 위해 5초 기다리는 게 나아요. 속도도 중요하지만, 안전이 최우선이에요! ⚡",
    expB: "UI는 사용자 경험에 중요하지만 안전에는 치명적이지 않아요! 올바른 의료 조언을 주는 못생긴 인터페이스가 심장마비에 아로마 오일을 권하는 예쁜 인터페이스보다 나아요. 예쁜 것이 생명을 구하지는 못해요! 🎨",
    expC: "완벽해요! 의료 AI는 정확하고 편견이 없어야 해요 - 사람의 생명이 달려있거든요! 봇이 심장 발작에 아로마 오일을 권한다면 예쁜 인터페이스는 도움이 안 돼요. 그래서 AI 테스팅은 기능 테스트를 넘어서는 거예요 - 안전성, 편견, 윤리적 문제까지 테스트해요! 🏥⚕️",
    expD: "메모리는 성능에 중요하지만 주요 안전 문제는 아니에요! 챗봇이 메모리를 많이 사용하더라도, 그건 인프라 문제예요. 잘못된 의료 조언은 생명을 위협하는 문제죠! 💾",
    points: 1,
    chapter: "AI 기반 시스템의 품질 특성",
    difficulty: "K1"
  },
  {
    id: 4,
    text: "AI 채용 시스템이 계속해서 여성 지원자들을 거부합니다. 문제가 무엇인가요?",
    options: [
      "시스템이 지원서를 처리하기 위해 더 강력한 GPU가 필요함",
      "시스템이 피크 시간에 너무 느리게 작동함",
      "사용자 인터페이스가 HR 직원들을 혼란스럽게 함",
      "시스템이 과거 채용 데이터에서 편견을 학습함"
    ],
    correct: 3,
    expA: "하드웨어는 상관없어요! 더 많은 GPU가 편견을 고치지는 못해요 - 편견 있는 결정을 더 빨리 내릴 뿐이죠! 잘못된 방향으로 가고 있는데 더 빠른 차를 사는 것과 같아요. 🚗💨",
    expB: "속도가 문제가 아니에요! 느리지만 공정한 시스템이 빠르지만 편향된 시스템보다 나아요. 느린 건 더 나은 인프라로 고칠 수 있지만, 편견은 데이터와 알고리즘의 근본적 변화가 필요해요. ⏱️",
    expC: "UI 혼란으로는 여성 지원자들의 체계적 거부를 설명할 수 없어요! HR 직원들이 혼란스러워해도, 이런 패턴은 알고리즘 편향을 보여주는 것이지 사용자 오류가 아니에요. 인터페이스 문제가 성별 차별을 만들지는 않아요. 🖥️",
    expD: "정확해요! AI는 훈련 데이터에서 인간의 편견을 학습할 수 있어요! 과거 채용이 편향되어 있었다면, AI는 나쁜 농담을 반복하는 앵무새처럼 그 편견을 학습해요. 그래서 공정성 테스팅이 중요한 거예요 - AI가 우리의 최악의 습관을 영속화하는 걸 원하지 않거든요! 👩‍💼⚖️",
    points: 1,
    chapter: "AI 기반 시스템의 품질 특성",
    difficulty: "K2"
  },
  {
    id: 5,
    text: "AI 시스템을 기존 소프트웨어 대비 테스트하기 어렵게 만드는 근본적인 요인은 무엇인가요?",
    options: [
      "AI 시스템은 항상 더 비싼 하드웨어가 필요함",
      "AI 시스템은 확률적이어서 같은 입력에 다른 출력을 줄 수 있음",
      "AI 시스템은 설치와 구성이 더 복잡함",
      "AI 시스템은 특별한 프로그래밍 언어가 필요함"
    ],
    correct: 1,
    expA: "하드웨어 비용은 주요 테스팅 도전이 아니에요! 네, AI는 실행 비용이 클 수 있지만, 그건 리소스 문제지 근본적인 테스팅 도전이 아니에요. 더 작은 데이터셋이나 클라우드에서 테스트할 수 있거든요. 💰",
    expB: "정확해요! 예측 가능한 기존 소프트웨어(자판기 같은)와 달리, AI는 확률적이어서 매번 다른 (하지만 유효한) 답을 줄 수 있어요! 테스팅은 이런 불확실성을 다뤄야 해요. 친구에게 맛집 추천을 물어보는 것과 같아요 - 기분에 따라 다른 답을 받겠죠! 🎲",
    expC: "설치 복잡성은 AI만의 문제가 아니에요! 많은 기존 엔터프라이즈 시스템들도 설치가 복잡해요. 진짜 도전은 테스팅 중 AI 모델의 비결정적 행동이에요. 🔧",
    expD: "프로그래밍 언어는 주요 문제가 아니에요! AI에는 Python, R, Java 등 많은 언어를 쓸 수 있어요. 도전은 AI가 우리가 예측할 수 없는 패턴을 학습한다는 것이지, 어떤 언어로 작성되었는지가 아니에요. 👨‍💻",
    points: 1,
    chapter: "AI 개론",
    difficulty: "K2"
  },
  {
    id: 6,
    text: "자율주행차 AI를 테스트하고 있습니다. 반드시 포함할 시나리오는 무엇인가요?",
    options: [
      "완벽한 도로에서 맑은 날씨의 일반적인 운전만",
      "일정한 속도로 고속도로 운전만",
      "극한 날씨, 공사 구간, 응급 상황",
      "장애물 없는 주차장에서 연습만"
    ],
    correct: 2,
    expA: "너무 제한적이에요! 완벽한 조건만 테스트하는 건 유아 풀에서 수영을 배우고 바로 바다로 뛰어드는 것과 같아요. 실제 운전에는 비, 보행자, 그리고 방향지시등을 옵션으로 생각하는 운전자들이 있어요! ☀️",
    expB: "충분히 다양하지 않아요! 고속도로 운전은 중요하지만, 차들은 시내 도로, 스쿨존, GPS가 항상 헷갈리는 그 교차로도 다뤄야 해요. 다양성이 견고한 AI의 핵심이에요! 🛣️",
    expC: "정확해요! 자율주행차는 모든 것을 다뤄야 해요 - 비, 눈, 공사, 응급상황, 그리고 아마 쇼핑백이 날아다니는 상황까지도! '행복한 경로'만 테스트하는 건 위험해요. 진짜 AI 테스팅에는 극단적 케이스, 스트레스 시나리오, 안전에 중요한 상황들이 필요해요! 🚗🌧️",
    expD: "너무 안전해요! 주차장은 기본기에는 좋지만, 차들은 실제 혼돈을 다뤄야 해요 - 걸으면서 문자하는 보행자들이나 갑자기 나타나는 자전거 타는 사람들 말이에요. 안전하게 시작하되, 혼돈을 테스트하세요! 🅿️",
    points: 2,
    chapter: "AI 기반 시스템의 품질 특성",
    difficulty: "K3"
  },
  {
    id: 7,
    text: "AI 시스템이 테스트에서는 완벽하게 작동하지만 프로덕션에서는 실패합니다. 가장 가능성 있는 원인은 무엇인가요?",
    options: [
      "프로덕션 서버가 부하를 처리하기 위해 더 많은 RAM이 필요함",
      "사용자들이 올바른 사용법 지침을 따르지 않음",
      "데이터베이스 연결이 잘못 구성됨",
      "실제 데이터 분포가 테스트 데이터와 다름"
    ],
    correct: 3,
    expA: "RAM이 문제일 수 있지만, 보통 성능 문제를 일으키지 시스템 장애를 일으키지는 않아요. AI 로직이 테스트에서 작동했다면, 더 많은 메모리로는 근본적인 데이터 분포 문제를 해결할 수 없어요. 🖥️",
    expB: "사용자 오류는 가능하지만, 시스템이 통제된 사용자로 테스트에서 작동했다면 문제는 더 깊은 곳에 있을 가능성이 높아요. AI는 어느 정도의 사용자 변동성을 다룰 수 있을 만큼 견고해야 해요. 사용자를 먼저 탓하지 마세요! 👥",
    expC: "데이터베이스 구성이 성능에 영향을 줄 수 있지만, AI가 테스트에서 작동했다면 데이터베이스 문제는 다른 증상을 보였을 거예요. 이건 데이터 품질/분포 문제처럼 들려요. 🗄️",
    expD: "정확해요! 이게 바로 고전적인 '훈련 대 현실' 문제예요! 완벽한 테스트 데이터로 훈련된 AI는 지저분한 실제 데이터와 씨름할 수 있어요. 게임에서 운전을 배우고 실제 교통상황에서 운전하려는 것과 같아요 - 현실은 아파요! 📊➡️🌍",
    points: 2,
    chapter: "AI 기반 시스템의 품질 특성",
    difficulty: "K3"
  },
  {
    id: 8,
    text: "머신러닝과 기존 프로그래밍 접근법의 핵심 차이점은 무엇인가요?",
    options: [
      "기존 프로그래밍은 우리가 작성한 규칙을 따름; ML은 데이터에서 패턴을 학습함",
      "ML은 항상 기존 프로그래밍보다 훨씬 빠름",
      "ML은 숫자 데이터만 처리, 기존 프로그래밍은 텍스트 처리",
      "ML은 특별한 비싼 하드웨어가 필요, 기존 프로그래밍은 불필요"
    ],
    correct: 0,
    expA: "완벽해요! 기존 프로그래밍: 우리가 규칙을 써요 (레시피처럼). ML: 예시를 보여주면, AI가 패턴을 찾아요! 예시로 아이를 가르치는 것과 단계별 지침을 주는 것의 차이예요. 둘 다 작동하지만, ML은 우리가 존재조차 몰랐던 패턴을 찾아내요! 🧠📚",
    expB: "속도는 핵심 차이가 아니에요! ML은 작업에 따라 더 빠르거나 느릴 수 있어요. 때로는 기존 알고리즘이 더 빨라요! 핵심 차이는 문제를 어떻게 해결하는지예요 - 규칙 대 패턴 학습. ⚡",
    expC: "데이터 타입은 핵심 차이가 아니에요! 둘 다 텍스트, 숫자, 이미지 등을 다룰 수 있어요. ML은 텍스트를 훌륭하게 처리해요 (이 대화처럼!), 기존 프로그래밍도 숫자를 완벽하게 다뤄요. 📊📝",
    expD: "하드웨어 요구사항은 결정적 요인이 아니에요! 노트북이나 심지어 폰에서도 ML을 할 수 있어요. 기존 프로그래밍도 복잡한 애플리케이션에서는 강력한 하드웨어가 필요할 수 있어요. 접근법이 중요한 거지, 하드웨어가 아니에요! 💻",
    points: 1,
    chapter: "AI 개론",
    difficulty: "K1"
  },
  {
    id: 9,
    text: "'설명가능성'이 AI 시스템의 법적 요구사항이 되는 이유는 무엇인가요?",
    options: [
      "AI 시스템이 데이터를 훨씬 빨리 처리하게 함",
      "특히 중요한 선택에서 AI가 왜 그런 결정을 내렸는지 이해하는 데 도움이 됨",
      "AI 개발 비용을 크게 줄임",
      "AI 시스템이 사용자에게 더 전문적으로 보이게 함"
    ],
    correct: 1,
    expA: "속도는 설명가능성의 목표가 아니에요! 실제로 설명가능성을 추가하면 설명을 생성해야 하므로 시스템이 느려질 수 있어요. 목표는 이해이지, 속도가 아니에요. ⚡",
    expB: "정확해요! 설명가능성은 신뢰, 안전, 법적 준수에 중요해요! AI가 당신의 대출이나 의료 치료를 거부한다면, 이유를 알 자격이 있어요. '블랙박스가 그렇게 말했으니까'로는 충분하지 않아요 - AI가 수학 시간처럼 자신의 작업을 보여줘야 해요! 🤔💡",
    expC: "비용 절감이 주요 목표는 아니에요! 설명가능성은 복잡성을 추가하므로 종종 개발 비용을 증가시켜요. 하지만 신뢰와 준수를 위해서는 그만한 가치가 있어요. AI를 위한 보험이라고 생각하세요! 💰",
    expD: "전문적 외관이 주요 이유는 아니에요! 설명가능성은 법적 준수와 신뢰에 관한 것이지, 겉치레가 아니에요. 투명한 결정이 결정 방식을 숨기는 예쁜 인터페이스보다 중요해요. ✨",
    points: 1,
    chapter: "AI 기반 시스템의 품질 특성",
    difficulty: "K2"
  },
  {
    id: 10,
    text: "다양한 인구통계학적 그룹에 대한 AI 시스템의 공정성을 테스트할 때 가장 큰 도전은 무엇인가요?",
    options: [
      "공정성 테스팅에는 전문적이고 비싼 하드웨어가 필요함",
      "AI 시스템이 데이터를 너무 빨리 처리해서 공정성 모니터링이 어려움",
      "'공정한' 것이 무엇인지 정의하는 것이 주관적이고 맥락에 따라 달라질 수 있음",
      "대부분의 AI 시스템이 공정성 테스팅하기에는 너무 복잡함"
    ],
    correct: 2,
    expA: "하드웨어는 주요 문제가 아니에요! 일반 컴퓨터에서도 공정성을 테스트할 수 있어요 - 컴퓨팅 파워보다는 통계 분석에 관한 거예요. 진짜 도전은 공정함이 무엇을 의미하는지 정의하는 것이에요! 💻",
    expB: "처리 속도는 장애물이 아니에요! 결정을 로그하고 나중에 분석할 수 있어요. 속도는 실제로 도움이 돼요 - 공정성 패턴을 분석할 더 많은 데이터 포인트가 생기거든요! 도전은 철학적인 것이지, 기술적인 게 아니에요. ⚡",
    expC: "절대적으로 맞아요! 공정성은 단순한 기술적 문제가 아니라 인간 가치의 문제예요! 채용에서 '공정한' 것과 대출에서 '공정한' 것이 다를 수 있어요. 방 가득한 사람들에게 피자 토핑에 동의하라고 하는 것과 같아요 - 맥락이 중요하고 모든 사람이 의견을 가지고 있어요! ⚖️🤝",
    expD: "복잡성은 관리 가능해요! 공정성 테스팅을 위한 통계 도구와 프레임워크가 있어요. 진짜 도전은 시스템의 복잡성이 아니라 공정성 자체를 정의하는 복잡성이에요. 🧮",
    points: 2,
    chapter: "AI 기반 시스템의 품질 특성",
    difficulty: "K3"
  },
  {
    id: 11,
    text: "AI 추천 시스템이 사용자에게 유사한 콘텐츠만 보여주는 '필터 버블'을 만듭니다. 이것은 어떤 AI 테스팅 문제를 보여주나요?",
    options: [
      "사용자 선호도에 대한 완벽한 알고리즘 최적화",
      "고효율 콘텐츠 처리 및 전달",
      "개인화를 통한 뛰어난 사용자 경험",
      "예상치 못한 시스템 동작과 윤리적 함의"
    ],
    correct: 3,
    expA: "문제를 만든다면 완벽하지 않아요! 네, 알고리즘이 선호도에 최적화되어 있지만, 완벽한 최적화가 의도치 않은 결과를 가져올 수 있어요. 때로는 '완벽한' 것이 너무 과할 수 있어요! 🎯",
    expB: "효율성이 문제가 아니에요! 시스템이 효율적으로 콘텐츠를 전달하지만, 효율성만으로는 충분하지 않아요. 사용자와 사회에 미치는 더 넓은 영향도 고려해야 해요. 🚀",
    expC: "사용자 경험이 뛰어나 보일 수 있지만, 필터 버블은 실제로는 다양한 관점에 대한 노출을 제한하여 사용자에게 해를 끼칠 수 있어요. 때로는 좋은 UX에도 숨겨진 비용이 있어요! 😊",
    expD: "정확해요! 필터 버블은 AI가 의도치 않은 결과를 가져올 수 있음을 보여줘요! 효율적이긴 하지만, 발견을 제한하고 편견을 강화할 수 있어요. 액션 영화 하나를 좋아했다고 액션 영화만 추천하는 친구를 두는 것과 같아요 - 다양성이 인생의 양념이거든요! 🔄📱",
    points: 2,
    chapter: "AI 기반 시스템의 품질 특성",
    difficulty: "K3"
  },
  {
    id: 12,
    text: "전문적인 AI 테스팅의 궁극적인 목표는 무엇인가요?",
    options: [
      "AI 시스템이 사용자에게 안전하고 신뢰할 수 있으며 유익하도록 보장하는 것",
      "AI 시스템이 어떤 하드웨어에서든 가능한 한 빠르게 실행되도록 하는 것",
      "AI 시스템을 최대한 복잡하고 기능이 풍부하게 만드는 것",
      "AI 시스템이 모바일 기기에 배포될 수 있도록 보장하는 것"
    ],
    correct: 0,
    expA: "완벽해요! 궁극적인 목표는 사람들을 안전하고 신뢰할 수 있게 도와주는 AI를 만드는 것이에요! 속도와 복잡성은 좋은 보너스지만, 안전과 신뢰성이 우선이에요. 다리를 건설하는 것과 같아요 - 예쁘거나 빠르게 건널 수 있기 전에 먼저 안전해야 해요! 🛡️✨",
    expB: "속도는 중요하지만 궁극적인 목표는 아니에요! 잘못된 답을 주는 빠른 시스템은 도움이 안 돼요. 중요한 결정을 신뢰할 수 있는 약간 느린 시스템이 나아요. 🏃‍♂️",
    expC: "복잡성을 위한 복잡성은 목표가 아니에요! 때로는 단순한 게 더 나아요. 최고의 AI는 인상적이기보다는 실제 문제를 우아하게 해결해요. 기능 팽창은 실제로 시스템을 더 나쁘게 만들 수 있어요! 🔧",
    expD: "모바일 배포는 유용하지만, 배포 옵션 중 하나일 뿐이에요! 궁극적인 목표는 더 넓어요 - AI가 모바일, 데스크톱, 클라우드 어디서든 인류를 잘 섬기도록 보장하는 것이에요. 📱",
    points: 1,
    chapter: "AI 개론",
    difficulty: "K1"
  }
];